import { makeMainUrl } from '../../../shared/util/url';
import { SEARCH_TAB_MAP } from './const';
import { unEscaper } from '@modules/Util/S/Function/util';

export const generateSearchUrl = (search: string, tab?: keyof typeof SEARCH_TAB_MAP): string => {
  return makeMainUrl(
    `/${ET.lang}/@/search?keyword=${encodeURIComponent(unEscaper(search))}${tab ? `&tab=${tab}` : ''}`,
  );
};

export const generateCreatorShopSearchUrl = (search: string, domain_name: string): string => {
  return makeMainUrl(`/${ET.lang}/${domain_name}/search?keyword=${encodeURIComponent(unEscaper(search))}`);
};
